import styled from 'styled-components/macro'
import { em } from '../../utils/styles'

const TableList = styled.table`
  margin: 1.75rem 0;
  border-spacing: 0;
  font-size: ${em(15)};
  width: 100%;
`

export default TableList
